import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '平台分类',
    links: [
      { label: '高清超清平台', path: '/category/hd' },
      { label: 'VR虚拟现实平台', path: '/category/vr' },
      { label: '直播互动平台', path: '/category/live' },
      { label: '经典珍藏平台', path: '/category/classic' },
      { label: '移动端平台', path: '/category/mobile' },
    ],
  },
  {
    title: '使用指南',
    links: [
      { label: '安全访问指南', path: '/article/safe-access-guide' },
      { label: 'VR体验指南', path: '/article/vr-adult-guide' },
      { label: '画质选购指南', path: '/article/hd-quality-guide' },
      { label: '订阅省钱攻略', path: '/article/subscription-saving-tips' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '免责声明', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-primary-500 cursor-pointer">
              Ultra<span className="text-foreground-800">Guide</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-500 leading-relaxed">
              专业的欧美无码正版内容平台推荐指南，致力于为成年用户提供客观、全面的平台评测与观看指南。
            </p>
            <p className="mt-3 text-xs text-foreground-400">
              本网站仅供18岁以上成年人访问
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 UltraGuide. 本网站内容仅供信息参考，请遵守当地法律法规。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}